import React, {PureComponent} from 'react';
import {Input} from 'reactstrap';


export default class ChatField extends PureComponent {

    render() {
        return (

            <div  style={{marginTop: '5px'}}>
                <textarea
                       //style={{fontWeight: 'bold', border: '4px solid red', minHeight: 0, resize: 'none'}}
                        style={{fontWeight: 'bold', border: '4px solid red', resize: 'none'}}
                       rows="4"
                       name="chatField"
                       placeholder="הקלד כאן הערה לתפעול...."
                       value={this.props.comment}
                       onChange={(e) => this.props.updateComment(e.target.value, this.props.type)}
                />

            </div>
        )
    }
}
;


